import { AxiosError } from 'axios';

export const isHttp4xx = (error: AxiosError): boolean => {
  if (error.response && error.response.status >= 400 && error.response.status < 499) {
    return true;
  } else {
    return false;
  }
};
